import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  titleWithBrand: (brandName: string) => ({
    key: 'ZaiHero-title-with-brand',
    parameters: {
      brandName,
    },
    defaultValue: 'Boas-vindas ao brandspace de {brandName}',
  }),
  title: {
    key: 'ZaiHero-title',
    defaultValue: 'Boas-vindas',
  },
})
